module.exports = __webpack_public_path__ + "static/img/pk.07aa815e.png";